import { FC } from 'react';
import AdminButtonNavigation from 'ui/AdminButtonNavigation';
import * as Icons from 'ui/Icons';
import NavSideBar from 'ui/NavSideBar';
import AdminNav from 'ui/theme/Header/data/AdminNav.json';
import SalesRepNav from 'ui/theme/Header/data/SalesRepNav.json';
import Navbar from 'ui/theme/Header/Navbar';
import { LayoutInterface } from 'ui/uiTypes';
import { useDetectMobileDevice } from 'utils/hooks/useWindow';

import {
  NavigationContainer,
  NavItem,
  SalesRepWrapper,
  SideBarContainer,
  Wrapper,
} from './styles';

interface HeaderProps {
  showLinks?: boolean;
  isAdmin?: boolean;
  showSidebars?: boolean;
  forGuide?: boolean;
  hideTopNav?: boolean;
  isAdvisorView?: boolean;
  isAdminPortalPage?: boolean;
  isSalesrepShadow?: boolean;
  handleNavigationClick?: (link: string) => void;
  handleAdvisorViewOpen?: () => void;
}

const Header: FC<HeaderProps & LayoutInterface> = ({
  variant,
  showLinks,
  showSidebars,
  leftLoggedingMenu,
  rightNonLoggMenu,
  isAdmin,
  isSalesRep,
  adminIsAuthenticated,
  title,
  hideTopNav,
  isAdvisorView,
  isAdminPortalPage,
  isSalesrepShadow,
  handleNavigationClick,
  handleAdvisorViewOpen,
}) => {
  if (isSalesRep) {
    const { isMobileDevice } = useDetectMobileDevice();
    const isLoading = isMobileDevice === undefined;
    return (
      <>
        {!isLoading && (
          <>
            <SalesRepWrapper
              variant={variant}
              isSalesRep={isSalesRep}
              isMobile={isMobileDevice}
            >
              {!hideTopNav && (
                <Navbar
                  {...{
                    showSidebars,
                    showLinks,
                    variant,
                    leftLoggedingMenu,
                    rightNonLoggMenu,
                    isAdmin,
                    isAdminPortalPage,
                    isSalesRep,
                    isSalesrepShadow,
                    title,
                  }}
                />
              )}
            </SalesRepWrapper>

            {!isMobileDevice && (
              <NavSideBar active={true} side="left" isSalesRep={true}>
                <SideBarContainer>
                  <NavigationContainer>
                    {SalesRepNav.map((val) => (
                      <NavItem key={`${val.hrefLink}-${val.LinkTitle}`}>
                        <AdminButtonNavigation
                          hrefLink={val.hrefLink}
                          Icon={Icons[val.Icon]}
                          LinkTitle={val.LinkTitle}
                        />
                      </NavItem>
                    ))}
                  </NavigationContainer>
                </SideBarContainer>
              </NavSideBar>
            )}
          </>
        )}
      </>
    );
  }
  return (
    <>
      <Wrapper variant={variant} isAdmin={isAdmin}>
        <Navbar
          {...{
            showSidebars,
            showLinks,
            variant,
            leftLoggedingMenu,
            rightNonLoggMenu,
            isAdmin,
            isAdminPortalPage,
            isAdvisorView,
            handleAdvisorViewOpen,
            handleNavigationClick,
          }}
        />
      </Wrapper>
      {(isAdminPortalPage || (isAdmin && adminIsAuthenticated)) && (
        <NavSideBar active={true} side="left" isAdmin>
          <SideBarContainer>
            <NavigationContainer>
              {AdminNav.map((val) => (
                <NavItem key={`${val.hrefLink}-${val.LinkTitle}`}>
                  <AdminButtonNavigation
                    hrefLink={val.hrefLink}
                    Icon={Icons[val.Icon]}
                    LinkTitle={val.LinkTitle}
                    handleNavigationClick={handleNavigationClick}
                  />
                </NavItem>
              ))}
            </NavigationContainer>
          </SideBarContainer>
        </NavSideBar>
      )}
    </>
  );
};

export default Header;
